


import { Component, OnInit } from "@angular/core";

export interface GuardianCard {
  title: string;
  information: string;
  url_img: string;
  url_qr: string | null;
  url_pdf: string | null;
  design: string;
  width_lg: string;
  width_md: string;
  bg_color: string;
  min_height: string;
  fxFlex: string;
}


@Component({
  selector: "app-guardianes-view",
  templateUrl: "./guardianes-view.component.html",
  styleUrls: ["./guardianes-view.component.css"],
})
export class GuardianesViewComponent implements OnInit {
  constructor() { }

  // Huancavelica
  guardian_card_list_1: GuardianCard[] = [
    {
      title: 'Alejandro Barra Pariona',
      information: 'Estamos recuperando algunas variedades de papas nativas que hemos perdido traendo semillas de otras zonas.',
      url_img: 'https://wikipapa.org/images/huanca-2-alejandro-barra.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanca-2-alejandro-barra.png',
      url_pdf: 'https://wikipapa.org/docs/huanca-2-alejandro-barra.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Espirita Guerrero Romero',
      information: 'Nosotros cultivamos papa nativa sana, en forma natural no usamos químicos, todos con productos orgánicos.',
      url_img: 'https://wikipapa.org/images/huanca-4-espirita-guerrero.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanca-4-espirita-guerrero.png',
      url_pdf: 'https://wikipapa.org/docs/huanca-4-espirita-guerrero.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Felipa Llaccta Choccelagua',
      information: 'Las papitas nativas son el tesoro de los Andes que nos ha dejado nuestros abuelos.',
      url_img: 'https://wikipapa.org/images/huanca-5-felipa-llaccta.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanca-5-felipa-llaccta.png',
      url_pdf: 'https://wikipapa.org/docs/huanca-5-felipa-llaccta.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Maximo Parianshullca Paitan',
      information: 'Conservar las diferentes variedades de papas nativas me ha permitido conocer a otros agricultores que cuidan las papas.',
      url_img: 'https://wikipapa.org/images/huanca-6-maximo-parianshullca.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanca-6-maximo-parianshullca.png',
      url_pdf: 'https://wikipapa.org/docs/huanca-6-maximo-parianshullca.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Jesus Nicanor Ataypoma Centeno',
      information: 'Conservamos las papas nativas por su color, sabor, forma y también porque nos gusta.',
      url_img: 'https://wikipapa.org/images/huanca-7-nicanor-ataypoma.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanca-7-nicanor-ataypoma.png',
      url_pdf: 'https://wikipapa.org/docs/huanca-7-nicanor-ataypoma.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Sebastian Alanya Condori',
      information: 'Soy anciano pero incentivo a los otros comuneros y a los jóvenes a sembrar las diferentes variedades de papas nativas que hay en nuestra comunidad para que no se pierdan.',
      url_img: 'https://wikipapa.org/images/huanca-9-sebastian-alanya.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanca-9-sebastian-alanya.png',
      url_pdf: 'https://wikipapa.org/docs/huanca-9-sebastian-alanya.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Vilma Morillo Vda. de Castillo',
      information: 'Siembro papas nativas con la ayuda de mis hijos porque me gusta y no quiero perder las diferentes variedades que me dejo mi esposo.',
      url_img: 'https://wikipapa.org/images/huanca-13-vilma-morillo.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanca-13-vilma-morillo.png',
      url_pdf: 'https://wikipapa.org/docs/huanca-13-vilma-morillo.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Elmer Chavez Perez',
      information: 'Nuestras papas son orgánicas, libres de agroquímicos. Cultivabamos las papas trabajando la tierra, todos los miembros de la familia participan desde el siembra hasta la cosecha.',
      url_img: 'https://wikipapa.org/images/huanca-15-elmer-chavez.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanca-15-elmer-chavez.png',
      url_pdf: 'https://wikipapa.org/docs/huanca-15-elmer-chavez.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Alberto Lanasca Carbajal',
      information: 'La papa nativa es el cultivo más importante de nuestra familia.',
      url_img: 'https://wikipapa.org/images/huanca-1-alberto-lanasca.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanca-1-alberto-lanasca.png',
      url_pdf: 'https://wikipapa.org/docs/huanca-1-alberto-lanasca.pdf',
      design: 'ver_2',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#e1f2fe',
      min_height: '160px',
      fxFlex: '100',
    },
    {
      title: 'Rufina Carrera Echevarria',
      information: 'Mi esposo y yo decidimos seguir manteniendo la tradición de cultivar papas nativas, nos es difícil pero nos gusta.',
      url_img: 'https://wikipapa.org/images/huanca-8-rufina-carrera.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanca-8-rufina-carrera.png',
      url_pdf: 'https://wikipapa.org/docs/huanca-8-rufina-carrera.pdf',
      design: 'ver_2',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#e1f2fe',
      min_height: '160px',
      fxFlex: '100',
    },
    {
      title: 'Juana Adela Segama Belito',
      information: 'Conservo las papas nativas porque es herencia de mis padres, me gustan todos sus sabores y colores.',
      url_img: 'https://wikipapa.org/images/huanca-10-juana-segama.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanca-10-juana-segama.png',
      url_pdf: 'https://wikipapa.org/docs/huanca-10-juana-segama.pdf',
      design: 'ver_2',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#e1f2fe',
      min_height: '160px',
      fxFlex: '100',
    },
    {
      title: 'Juan Ramos Condori',
      information: 'Gracias a las papas nativas tuve la oportunidad de conocer muchos lugares de Huancavelica y del Perú. Yauli es conocido como la cuna de las papas nativas. ',
      url_img: 'https://wikipapa.org/images/huanca-11-juan-ramos.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanca-11-juan-ramos.png',
      url_pdf: 'https://wikipapa.org/docs/huanca-11-juan-ramos.pdf',
      design: 'ver_2',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#e1f2fe',
      min_height: '160px',
      fxFlex: '100',
    },
    {
      title: 'Francisco Salvatierra Taype',
      information: 'Cuando yo era niño había una gran diversidad de papas y otras que se han ido perdiendo. Ahora las estamos recuperando poco a poco.',
      url_img: 'https://wikipapa.org/images/huanca-16-francisco-salvatierra.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanca-16-francisco-salvatierra.png',
      url_pdf: 'https://wikipapa.org/docs/huanca-16-francisco-salvatierra.pdf',
      design: 'hor_1',
      width_lg: '49',
      width_md: '100',
      bg_color: '#ffeffe',
      min_height: '123.5px',
      fxFlex: '50',
    },
    {
      title: 'Elberto Montes Perez',
      information: 'Estas papas las tengo desde mi mamá y mis abuelos quienes las cultivaban antes, es por herencia, siempre he tenido más de 200 variedades.',
      url_img: 'https://wikipapa.org/images/huanca-17-elberto-montes.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanca-17-elberto-montes.png',
      url_pdf: 'https://wikipapa.org/docs/huanca-17-elberto-montes.pdf',
      design: 'hor_1',
      width_lg: '49',
      width_md: '100',
      bg_color: '#ffeffe',
      min_height: '123.5px',
      fxFlex: '50',
    },
    {
      title: 'Victor Torre Cueto',
      information: 'Conservo las papas nativas porque las aprecio mucho, tienen diferentes sabores y colores. Gracias a mis papas viajo mucho.',
      url_img: 'https://wikipapa.org/images/huanca-12-victor-torre.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanca-12-victor-torre.png',
      url_pdf: 'https://wikipapa.org/docs/huanca-12-victor-torre.pdf',
      design: 'ver_2',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#e1f2fe',
      min_height: '160px',
      fxFlex: '100',
    },
    {
      title: 'Leoncio Quinto Escobar',
      information: 'Desde hace más de 15 años siembro papas nativas para consumo y participar en ferias.',
      url_img: 'https://wikipapa.org/images/huanca-14-leoncio-quinto.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanca-14-leoncio-quinto.png',
      url_pdf: 'https://wikipapa.org/docs/huanca-14-leoncio-quinto.pdf',
      design: 'ver_2',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#e1f2fe',
      min_height: '160px',
      fxFlex: '100',
    },
    {
      title: 'Cesareo Escobar Ramos',
      information: 'Conservo a las papas nativas por su sabor, por su diferentes formas y también porque me gustan.',
      url_img: 'https://wikipapa.org/images/huanca-3-cesareo-escobar.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanca-3-cesareo-escobar.png',
      url_pdf: 'https://wikipapa.org/docs/huanca-3-cesareo-escobar.pdf',
      design: 'hor_1',
      width_lg: '49',
      width_md: '100',
      bg_color: '#ffeffe',
      min_height: '123.5px',
      fxFlex: '50',
    },

  ];

  // Huánuco
  guardian_card_list_2: GuardianCard[] = [
    {
      title: 'Bertha Naupay Ponce',
      information: 'Estoy enseñando a mis hijos para que ellos también puedan sembrar las papas nativas.',
      url_img: 'https://wikipapa.org/images/huanuco-1-bertha-naupay.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanuco-1-bertha-naupay.png',
      url_pdf: 'https://wikipapa.org/docs/huanuco-1-bertha-naupay.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Predesbinda Borja Beteta',
      information: 'Cada año puedo aumentar mis variedades intercambiando semillas',
      url_img: 'https://wikipapa.org/images/huanuco-2-predesbinda-borja.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanuco-2-predesbinda-borja.png',
      url_pdf: 'https://wikipapa.org/docs/huanuco-2-predesbinda-borja.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Ezequiel Raynaldo Ponciano Flores',
      information: 'Cultivamos la papa nativa con cariño, entre 300 a 350 variedades, y así el sembrío de papas nativas se está incrementando.',
      url_img: 'https://wikipapa.org/images/huanuco-3-ezequiel-ponciano.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanuco-3-ezequiel-ponciano.png',
      url_pdf: 'https://wikipapa.org/docs/huanuco-3-ezequiel-ponciano.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Gaudencia Martinez Rivas',
      information: 'Yo he nacido con las papas y las conservo porque tienen muchos sabores y colores.',
      url_img: 'https://wikipapa.org/images/huanuco-4-gaudencia-martinez.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanuco-4-gaudencia-martinez.png',
      url_pdf: 'https://wikipapa.org/docs/huanuco-4-gaudencia-martinez.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Wilder Eli Solorzano Armillon',
      information: 'Conocer a otros guardianes de otras regiones nos permite hacer intercambio de semillas de papas nativas y discutir  los problemas que afectan.',
      url_img: 'https://wikipapa.org/images/huanuco-8-wilder-solorzano.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanuco-8-wilder-solorzano.png',
      url_pdf: 'https://wikipapa.org/docs/huanuco-8-wilder-solorzano.pdf',
      design: 'hor_1',
      width_lg: '49',
      width_md: '100',
      bg_color: '#ffeffe',
      min_height: '123.5px',
      fxFlex: '50',
    },
    {
      title: 'Abdiaz Edwin Pujay Guzmane',
      information: 'Cultivar las papas nativas significa mantener la tradición ancestral, ser guardian es cuidar que no pierden las variedades que sembramos.',
      url_img: 'https://wikipapa.org/images/huanuco-7-edwin-pujay.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanuco-7-edwin-pujay.png',
      url_pdf: 'https://wikipapa.org/docs/huanuco-7-edwin-pujay.pdf',
      design: 'hor_1',
      width_lg: '49',
      width_md: '100',
      bg_color: '#ffeffe',
      min_height: '123.5px',
      fxFlex: '50',
    },
    {
      title: 'Victoriano Fernandez Morales',
      information: 'Estas papas las tengo desde mi mamá y mis abuelos quienes las cultivaban antes, es por herencia, siempre he tenido mas de 200 variedades.',
      url_img: 'https://wikipapa.org/images/huanuco-9-victoriano-fernandez.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanuco-9-victoriano-fernandez.png',
      url_pdf: 'https://wikipapa.org/docs/huanuco-9-victoriano-fernandez.pdf',
      design: 'ver_2',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#e1f2fe',
      min_height: '160px',
      fxFlex: '100',
    },
    {
      title: 'Dominga Gomez Esteban',
      information: 'Las papas nativas son herencias de nuestros antepasados que guardamos y atesoramos hasta nuestros días.',
      url_img: 'https://wikipapa.org/images/huanuco-5-dominga-gomez.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanuco-5-dominga-gomez.png',
      url_pdf: 'https://wikipapa.org/docs/huanuco-5-dominga-gomez.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Gregorio Gomez Cecilio',
      information: 'La papa es nuestro principal alimento sin ella podríamos pasar dificultades, nunca falta papas en nuestra casa',
      url_img: 'https://wikipapa.org/images/huanuco-6-gregorio-gomez.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-huanuco-6-gregorio-gomez.png',
      url_pdf: 'https://wikipapa.org/docs/huanuco-6-gregorio-gomez.pdf',
      design: 'ver_2',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#e1f2fe',
      min_height: '160px',
      fxFlex: '100',
    },


  ];

  // Junín
  guardian_card_list_3: GuardianCard[] = [
    {
      title: 'Alvina Adelina Poma Nuñez',
      information: 'Por mucho tiempo venimos sembrando las papas nativas con mi esposa y mis hijos, hemos aprendido a seleccionar  viendo las formas y colores después de cada cosecha.',
      url_img: 'https://wikipapa.org/images/junin-1-alvina-poma.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-junin-1-alvina-poma.png',
      url_pdf: 'https://wikipapa.org/docs/junin-1-alvina-poma.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Jose Avednigo Inga Bernabe',
      information: 'Cuando cosechamos las papas nativas lo hacemos con mucho cuidado  y cariño, con respeto por la agrobiodiversidad y a nuestros orígenes.',
      url_img: 'https://wikipapa.org/images/junin-3-jose-inga.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-junin-3-jose-inga.png',
      url_pdf: 'https://wikipapa.org/docs/junin-3-jose-inga.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Fortunato Berrospi Pacheco',
      information: 'Cada año cambiamos de chacra y de lugar para hacer descansar el suelo para que la producción siga siendo buena, si no hacemos eso la producción será muy poca.',
      url_img: 'https://wikipapa.org/images/junin-11-fortunato-berrospi.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-junin-11-fortunato-berrospi.png',
      url_pdf: 'https://wikipapa.org/docs/junin-11-fortunato-berrospi.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Marcelo Tiza Rodriguez',
      information: 'Siembro las papas nativas porque es una herencia de nuestros ancestros y nuestra preocupacion como guardianeses es conservar la biodiversidad de las papas.',
      url_img: 'https://wikipapa.org/images/junin-4-marcelo-tiza.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-junin-4-marcelo-tiza.png',
      url_pdf: 'https://wikipapa.org/docs/junin-4-marcelo-tiza.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Raul Sabino Apolinario Ames',
      information: 'Las papas que producimos son ricas, sabrosas y nutritivas, que aportan a la nutrición de la familia. ',
      url_img: 'https://wikipapa.org/images/junin-5-raul-apolinario.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-junin-5-raul-apolinario.png',
      url_pdf: 'https://wikipapa.org/docs/junin-5-raul-apolinario.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Roque Gaspar Contreras',
      information: 'Mi principal cultivo y alimento es la papa nativa, no sembramos papas blancas o mejoradas.',
      url_img: 'https://wikipapa.org/images/junin-6-roque-gaspar.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-junin-6-roque-gaspar.png',
      url_pdf: 'https://wikipapa.org/docs/junin-6-roque-gaspar.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Victoriano Esteban Meza Cotera',
      information: 'Nosotros conservamos las papas nativas porque estamos contribuyendo  a nuestro patrimonio,  historia y cultura.',
      url_img: 'https://wikipapa.org/images/junin-7-victoriano-meza.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-junin-7-victoriano-meza.png',
      url_pdf: 'https://wikipapa.org/docs/junin-7-victoriano-meza.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Romulo Bacilio Torres Lino',
      information: 'Mi familia cultiva las papas nativas desde nuestros abuelos, es una gran herencia que nos han dejado. En el campo mantienen su belleza por que sus flores son de diferente color. Así como la forma, color, pulpa y sabor de sus tubérculos.',
      url_img: 'https://wikipapa.org/images/junin-12-romulo-torres.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-junin-12-romulo-torres.png',
      url_pdf: 'https://wikipapa.org/docs/junin-12-romulo-torres.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Dominica Cantorin Suazo',
      information: 'Conservo las diferentes variedades de papa nativa para recordar a mis abuelos y enseñamos a nuestros hijos a cuidarlas y mantenerlas.',
      url_img: 'https://wikipapa.org/images/junin-2-dominica-cantorin.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-junin-2-dominica-cantorin.png',
      url_pdf: 'https://wikipapa.org/docs/junin-2-dominica-cantorin.pdf',
      design: 'ver_2',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#e1f2fe',
      min_height: '160px',
      fxFlex: '100',
    },
    {
      title: 'Pedro Segundo Torres Leyva ',
      information: 'Todas las papas nativas actualmente tienen diferentes nombres, mi padre decía que son papas antiguas y por tanto deben conservar sus nombres en quechua.',
      url_img: 'https://wikipapa.org/images/junin-9-pedro-torres.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-junin-9-pedro-torres.png',
      url_pdf: 'https://wikipapa.org/docs/junin-9-pedro-torres.pdf',
      design: 'ver_2',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#e1f2fe',
      min_height: '160px',
      fxFlex: '100',
    },
    {
      title: 'Julian Yachachin Condor',
      information: 'Obtuve la pasión de recolectar papas de mi padre. Cuando yo era pequeño, él ya participaba en los mercados de semillas de papa y cuando envejeció me hice cargo de su trabajo.',
      url_img: 'https://wikipapa.org/images/junin-10-julian-condor.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-junin-10-julian-condor.png',
      url_pdf: 'https://wikipapa.org/docs/junin-10-julian-condor.pdf',
      design: 'ver_2',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#e1f2fe',
      min_height: '160px',
      fxFlex: '100',
    },
    {
      title: 'Walter Dictinio Espinoza Portalanza',
      information: 'Las papas nativas son como mis hijos porque les tengo que dedicar tiempo y paciencia.',
      url_img: 'https://wikipapa.org/images/junin-8-walter-espinoza.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-junin-8-walter-espinoza.png',
      url_pdf: 'https://wikipapa.org/docs/junin-8-walter-espinoza.pdf',
      design: 'hor_1',
      width_lg: '49',
      width_md: '100',
      bg_color: '#ffeffe',
      min_height: '123.5px',
      fxFlex: '50',
    },

  ];

  // Lima
  guardian_card_list_4: GuardianCard[] = [
    {
      title: 'Edgar Alberto Carlos Castillo',
      information: 'Conservó mis variedades desde mis ancestros como herencia de mis padres para que no se pierdan.',
      url_img: 'https://wikipapa.org/images/1-edgar-carlos.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-1-edgar-carlos.png',
      url_pdf: 'https://wikipapa.org/docs/1-edgar-carlos.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Mateo Jonas Chaverria Rojas',
      information: 'Queremos hacer una agricultura sana.',
      url_img: 'https://wikipapa.org/images/2-mateo-chaverria.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-2-mateo-chaverria.png',
      url_pdf: 'https://wikipapa.org/docs/2-mateo-chaverria.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Pedro Bernando Michue Rivera',
      information: 'Sembramos la papas desde nuestra juventud con nuestras familias.',
      url_img: 'https://wikipapa.org/images/3-pedro-michue.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-3-pedro-michue.png',
      url_pdf: 'https://wikipapa.org/docs/3-pedro-michue.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Ruth Victoriana Cueva de Villa',
      information: 'Tengo las papas nativas que mis abuelos me dejaron y las dejare a quienes vengan después de mí.',
      url_img: 'https://wikipapa.org/images/4-ruth-cueva.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-4-ruth-cueva.png',
      url_pdf: 'https://wikipapa.org/docs/4-ruth-cueva.pdf',
      design: 'hor_1',
      width_lg: '49',
      width_md: '100',
      bg_color: '#ffeffe',
      min_height: '123.5px',
      fxFlex: '50',
    },
    {
      title: 'Victor Agustin Lopez Lermo',
      information: 'Al morir nuestros padres nosotros continuamos conservando nuestras papas nativas.',
      url_img: 'https://wikipapa.org/images/5-victor-lopez.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-5-victor-lopez.png',
      url_pdf: 'https://wikipapa.org/docs/5-victor-lopez.pdf',
      design: 'hor_1',
      width_lg: '49',
      width_md: '100',
      bg_color: '#ffeffe',
      min_height: '123.5px',
      fxFlex: '50',
    },
    {
      title: 'Victor Jose Anco Chirinos',
      information: 'Muchas variedades se han perdido porque las familias han dejado de sembrar, somos pocos los que conservamos las diferentes variedades.',
      url_img: 'https://wikipapa.org/images/5-1-victor-anco.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-5-1-victor-anco.png',
      url_pdf: 'https://wikipapa.org/docs/5-1-victor-anco.pdf',
      design: 'hor_1',
      width_lg: '49',
      width_md: '100',
      bg_color: '#ffeffe',
      min_height: '123.5px',
      fxFlex: '50',
    },
  ];

  // Pasco
  guardian_card_list_5: GuardianCard[] = [
    {
      title: 'Aurea Eulalia Mendoza Capcha',
      information: 'Es una tradición conservar las papas nativas.',
      url_img: 'https://wikipapa.org/images/pasco-1-aurea-mendoza.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-pasco-1-aurea-mendoza.png',
      url_pdf: 'https://wikipapa.org/docs/pasco-1-aurea-mendoza.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Alda Haydee Chavez Callupe',
      information: 'Enseño a mi hija a seguir cultivando las papas nativas, para conservar las variedades que me dejo mi papá.',
      url_img: 'https://wikipapa.org/images/pasco-2-alda-chavez.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-pasco-2-alda-chavez.png',
      url_pdf: 'https://wikipapa.org/docs/pasco-2-alda-chavez.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Maria Judith Cosme Mandujano',
      information: 'Conservo las variedades de papas nativas, como herencia de mi abuelita.',
      url_img: 'https://wikipapa.org/images/pasco-3-maria-cosme.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-pasco-3-maria-cosme.png',
      url_pdf: 'https://wikipapa.org/docs/pasco-3-maria-cosme.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Mateo Zenon Panduro Callupe',
      information: 'Espero desarrollar lo que aprendí de mi papá para continuar sembrando papas nativas.',
      url_img: 'https://wikipapa.org/images/pasco-4-mateo-panduro.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-pasco-4-mateo-panduro.png',
      url_pdf: 'https://wikipapa.org/docs/pasco-4-mateo-panduro.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Modesto Idelberto Carhuaricra Morales',
      information: 'Pongo empeño en conservar mis papas nativas.',
      url_img: 'https://wikipapa.org/images/pasco-5-modesto-carhuaricra.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-pasco-5-modesto-carhuaricra.png',
      url_pdf: 'https://wikipapa.org/docs/pasco-5-modesto-carhuaricra.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },
    {
      title: 'Rosendo Meza Villanueva',
      information: 'Nosotros estamos cuidando la cultura lo que hacian nuestros antepasados. Ellos cultivaban las papas trabajando la tierra y hacian de estas actividades sus costumbres.',
      url_img: 'https://wikipapa.org/images/pasco-7-rosendo-villanueva.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-pasco-7-rosendo-villanueva.png',
      url_pdf: 'https://wikipapa.org/docs/pasco-7-rosendo-villanueva.pdf',
      design: 'ver_2',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#e1f2fe',
      min_height: '160px',
      fxFlex: '100',
    },
    {
      title: 'Marcial Floriano Taquire Usuriaga ',
      information: 'Siembro en mezcla porque las papas se protegen contra las heladas, granizadas y sequías. ',
      url_img: 'https://wikipapa.org/images/pasco-6-marcial-taquire.jpg',
      url_qr: 'https://wikipapa.org/images/qr-code-pasco-6-marcial-taquire.png',
      url_pdf: 'https://wikipapa.org/docs/pasco-6-marcial-taquire.pdf',
      design: 'ver_1',
      width_lg: '23.5',
      width_md: '49',
      bg_color: '#ffeffe',
      min_height: '180px',
      fxFlex: '100',
    },


  ];

  ngOnInit(): void { document.getElementsByClassName("head")[0].scrollIntoView(); }

  openPdf(url: any) {
    window.open(url, "_blank");
  }
}
